import './Home.css';

const HomeTitle = ({ shopBranchName, nameUser, lastnameUser, username }) => {
    
    return (
        
        <div className='homeTitleContainer'>
            <h1 className='homeTitle'>Bienvenidos a Qreate</h1>
            <br>
            </br>

            <h3 className='homeTitle2'><u>Sucursal:</u> {shopBranchName}</h3>
            <br>
            </br>

            <h3 className='homeTitle2'><u>Usuario:</u> {nameUser} {lastnameUser} ({username})</h3>
            <br>
            </br>
        </div>

    )

}

export default HomeTitle;